<template>
    <div v-if="summary != ''">
        {{ label }} {{summary}}
    </div>
</template>

<script>
export default {
    name: "KotobeeResourceSummary",
    props: {
        label: String,
        access: [Array, Object],
        type: String
    },
    computed: {
        summary() {
            const kRes = this.$store.state.kotobeeResources;
            const type = this.type;

            if (!this.access) return '';
            if (!kRes) return '';

            let accessArr = (Array.isArray(this.access)) ? this.access : Object.keys(this.access);
            let summaryArr = [];

            for (let k = 0; k < accessArr.length; k++) {
                const id = accessArr[k];
                let str = '';
                let kOb = null;

                if (type == 'cloudBooks') {
                    resourceLoop:
                    if (kRes.cloudBooks && kRes.cloudBooks.length) {
                        for (let i = 0; i < kRes.cloudBooks.length; i++) {
                            kOb = kRes.cloudBooks[i];
                            if (kOb.id == id) {
                                str = kOb.name;
                                break resourceLoop;
                            }
                        }
                    }
                } else if (type == 'libs') {
                    resourceLoop:
                    if (kRes.libs && kRes.libs.length) {
                        for (let i = 0; i < kRes.libs.length; i++) {
                            kOb = kRes.libs[i].lib;
                            if (kOb.id == id) {
                                str =  kOb.name;
                                break resourceLoop;
                            }
                        }
                    } 
                } else if (type == 'libBooks' || type == 'roles' || type == 'categories') {
                    if (kRes.libs && kRes.libs.length) {
                        libraryLoop:
                        for (let i = 0; i < kRes.libs.length; i++) {
                            let kObs = kRes.libs[i][type];
                            if (kObs.length) {
                                for (let j = 0; j < kObs.length; j++) {
                                    kOb = kObs[j];
                                    if (kOb.id == id) {
                                        str = kOb.name?kOb.name:kOb.title;
                                        break libraryLoop;
                                    } 
                                }
                            }
                        }
                    }
                }
                
                if (str) {
                    if (type == 'libBooks' || type == 'cloudBooks') {
                        if (this.access[id] && this.access[id]['chapters'] != '')
                            str += ' - Chapters: (' + this.access[id]['chapters'] + ')';
                    }
                    summaryArr.push(str);
                }
                
            }

            if (summaryArr.length)
                return summaryArr.join(', ');

            return '';

        }
    },
    mounted() {
        console.log("Kotobee Resource Summary mounted for type: " + this.type + " with access: ", this.access);
    }
}
</script>

<style scoped>

</style>